<template>
  <div>
    <a-banner @click.native="bannerClick" :kcData="kcData"></a-banner>
    <a-detail :data="data" :kcData="kcData" :show="showBox" @close="close" @btn1Click="openShare" @btn2Click="newActivity(true)"></a-detail>
    <a-share :showShare="showShare" @close="closeShare"></a-share>
    <loading style="z-index: 999" v-show="loading"></loading>
    <a-qr v-if="showQr" @close="closeQr" :src="qrSrc"></a-qr>
  </div>
</template>
<script type="text/ecmascript-6">
import ABanner from 'components/base/activity/zhuli/banner'
import ADetail from 'components/base/activity/zhuli/detail'
import AShare from 'components/base/activity/zhuli/share'
import AQr from 'components/base/activity/zhuli/qr-code'
import {newZhuli} from '@/api/activity/zhuli.js'
import {wxShare, zhuliShareConfig} from '@/api/wx-share.js'
import {RES_OK} from '@/api/config'
import {getCookie} from '@/utils/cookie.js'
import Loading from 'components/base/loading/loading.vue'
export default {
  props: {
    // 助力数据
    zhuliData: {
      type: Object,
      default: null
    },
    // 课程数据
    kcData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      data: {},
      // 助力主体框
      showBox: false,
      showShare: false,
      loading: false,
      // 未关注显示二维码
      showQr: false,
      // 未关注二维码的路径
      qrSrc: ''
    }
  },
  mounted() {
    // console.log(this)
    // 隐藏全局二维码弹框
    let popupGz = this.$root.$children[0].$refs.popupGz
    if (popupGz) {
      popupGz.style.display = 'none'
    }
    // 隐藏圣诞弹框
    // let popupChristmas = this.$root.$children[0].$refs.christmas
    // console.log(this.$root.$children[0])
    // if (popupChristmas) {
    // this.$root.$children[0].disabled = true
    // }
  },
  methods: {
    bannerClick() {
      // 发起新活动
      this.newActivity()
    },
    buildLink(aaid) {
      return location.protocol + '//' + location.host + '/?share_id=' + getCookie('uid') + '&anchor=' + encodeURIComponent(this.$route.path + '?aaid=' + aaid)
    },
    close() {
      this.showBox = false
    },
    closeShare() {
      this.showShare = false
    },
    // 关闭二维码窗口
    closeQr() {
      this.showQr = false
    },
    openShare() {
      this.showShare = true
    },
    // 发起新活动
    newActivity(showShare) {
      // console.log('发起助力')
      this.loading = true
      this.showBox = false
      // this.$emit('click')
      newZhuli(this.kcData.course_id, this.kcData.activity_id).then(res => {
        let data = res.data
        if (data && data.code === RES_OK && data.data) {
          this.loading = false
          // console.log(data.data)
          // 判断是否关注公众号
          if (data.data.status === -1 || data.data.status === '-1') {
            // 未关注公众号
            this.showQr = true
            this.qrSrc = data.data.qrcode_img_url
          } else {
            // 显示助力活动弹框
            this.showBox = true
            this.data = data.data
            if (showShare) {
              this.openShare()
            }
            // 微信分享
            let shareLink = {
              link: this.buildLink(this.data.activity_assistance_id)
            }
            console.log(zhuliShareConfig(this.kcData.numlimit))
            let sc = Object.assign({}, zhuliShareConfig(this.kcData.numlimit), shareLink)
            wxShare(sc, shareLink)
          }
        } else {
          this.loading = false
          let msg = data.msg || '系统异常'
          this.$toast(msg)
        }
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    }
  },
  components: {
    ABanner,
    ADetail,
    AShare,
    AQr,
    Loading
  },
  watch: {
    zhuliData(n) {
      this.data = n
      this.showBox = true
    }
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
</style>



// WEBPACK FOOTER //
// src/components/base/activity/zhuli/zhuli.vue